import React from "react";
import { Box } from "@chakra-ui/react";
import { Subtitle } from "./Texts";

const NoContentBox = ({children}) => <Box display="flex" height="400px" alignItems="center" justifyContent="center">
<Subtitle>{children}</Subtitle>
</Box>

export default NoContentBox;
